import { Title } from '@ui/components/title'
import QRCode from 'react-qr-code'
import { type FC, useEffect } from 'react'
import { useModal } from '@hooks/use-modal.ts'
import { isDevEnv } from '@utils/debug.ts'
import { useAppContext } from '@hooks/use-app-context'
import { useAtom, useSetAtom } from 'jotai'
import {
	analyticsCurrentAction,
	currentStepAtom,
	documentFlowVariantAtom,
} from '@store/atoms.ts'
import { useQR } from './hooks/use-qr'
import { StepsRichiesta } from '@store/stepsRichiesta'

import LoaderMaxi from '@ui/components/LoaderMaxi'

const LoadingScreen: FC = () => {
	const [activeStep] = useAtom(currentStepAtom) //STEP PADRE -contact, dati anagrafici
	const { close } = useModal()
	const setAnalyticsAction = useSetAtom(analyticsCurrentAction)

	useEffect(() => {
		setTimeout(() => {
			setAnalyticsAction('StepChangeToTablet')
		}, 100)
	}, [])

	console.log('ACTIVESTEP', activeStep)

	return (
	<div className='flex flex-col items-start gap-4 text-left'>
			<div className='text-2xl md:text-[28px] text-(--primary-blue) font-semibold'>
				Stiamo aspettando il caricamento dei documenti dal tuo smartphone o
				tablet.
			</div>
			<p className='font-medium md:text-[20px]'>
				Non chiudere questa pagina, al termine del caricamento potrai completare
				la richiesta di prestito.
			</p>

			<section className='flex justify-center items-center w-full p-2.5'>
  <LoaderMaxi />
</section>

			<div className='flex flex-row gap-4 justify-end w-full'>

				<div className='text-[16px]'>
					Vuoi cambiare metodo di inserimento dei tuoi dati?
				</div>
				<div>
					<button
						onClick={() => close()}
						className='flex hover:text-(--brand-green) cursor-pointer
                    underline underline-offset-4 decoration-2  text-(--green-default) font-bold
                     gap-2
                    
                    '
					>
						Cambia Modalità
					</button>
				</div>
			</div>
		</div>
	)
}

type ScanQRCodeProps = {
	onDebug?: () => void
	url: string
	showFullInfos: boolean
}

const ScanQRCode: FC<ScanQRCodeProps> = ({ url, showFullInfos }) => (
	<div className='flex flex-col gap-4'>
		<div className='text-2xl md:text-[28px] text-(--primary-blue) font-semibold'>
			Carica i tuoi documenti da smartphone
		</div>
		<p className='font-medium md:text-[20px]'>
			Inquadra il QR Code con la fotocamera o l'app dedicata, accedi alla pagina
			per il caricamento dei documenti e segui le indicazioni.
		</p>
		<div className='flex flex-row justify-around'>
			<div className='my-4 flex flex-col gap-16 px-8'>
				<QRCode value={url} size={150} />
			</div>

			<div className='text-left mt-4'>
				<p className='font-medium mb-2 text-(--primary-blue)'>
					Dopo aver caricato i documenti puoi:
				</p>
				<ul className='list-disc list-inside space-y-1 ms-2.5'>
					<li>
						Tornare su questa pagina, evitando di chiuderla, per completare la
						richiesta
					</li>
					<li>Proseguire con la richiesta sul tuo smartphone o tablet.</li>
				</ul>
			</div>
		</div>
	  {isDevEnv && <p className='text-sm break-all'>{url}</p>}

	</div>
)

const QRScanComponent: React.FC = () => {
	const [flowVariant, setDocumentFlowVariant] = useAtom(documentFlowVariantAtom)
	const {
		data: { useOnMobile, mobileToken, loadingToken },
	} = useQR()
	const [activeStep] = useAtom(currentStepAtom) //STEP PADRE -contact, dati anagrafici
	
	const { state, dispatch } = useAppContext()
	
	const sessione=state.data?.sessione 

	return (
		<div className='px-8'>
			{!useOnMobile && !loadingToken? (
				<ScanQRCode
					url={`${import.meta.env.VITE_QR_ENDPOINT}/preventivatore/Home/MobileUpload/${mobileToken}?docId=${flowVariant}&sessione=${encodeURIComponent(sessione ?? '')}`}
					// url={`${import.meta.env.VITE_QR_ENDPOINT}/preventivatore/Home/MobileUpload/${mobileToken}?docId=${flowVariant}`}
					showFullInfos={activeStep === StepsRichiesta.CONTATTI}
				/>
			) : (
				<LoadingScreen/>
			)}
		</div>
	)
}

export { QRScanComponent }
